<template>
    <div class="client-card">
      <div class="left">
        <a :href="dealLink" class="deal-name">
          {{ dealId }} - {{ name }}
        </a>
        <span class="unit">{{ unit }}</span>
        <div class="avatars">
          <img
            v-for="(img, idx) in avatars"
            :key="idx"
            :src="img"
            class="avatar"
          />
        </div>
      </div>
      <div class="right">
        <div class="info-line" v-if="whatsapp">
          <i class="fa-brands fa-whatsapp" style="color: #4caf50" />
          <span>{{ whatsapp }}</span>
        </div>
        <div class="info-line" v-if="email">
          <i class="fa-regular fa-envelope" style="color: #ffb300" />
          <span>{{ email }}</span>
        </div>
        <div class="info-line" v-if="cpf">
          <i class="fa-regular fa-id-badge" style="color: #8e24aa" />
          <span>{{ cpf }}</span>
        </div>
      </div>
    </div>
</template>
  
<script>
export default {
    name: 'ClientInfoCards',
    props: {
        name: String,
        unit: String,
        dealId: [String, Number],
        whatsapp: String,
        email: String,
        cpf: String,
        dealLink: String,
        avatars: {
            type: Array,
            default: () => []
        }
    }
}
</script>
  
<style scoped lang="stylus">
@import './styles.styl'
</style>
  